import * as React from "react";
import { Placeholder, Divider, Image, Grid } from "semantic-ui-react";

import { StyledOrganizationCard } from "../../../styles/CardStyles";
import { PLACEHOLDER_SQUARE } from "../../../images/imageSources";

export interface CardLoaderProps {}

const BigListLoader: React.FC<CardLoaderProps> = () => (
  <>
    <Grid.Column>
      <StyledOrganizationCard>
        <div id="image">
          <Image src={PLACEHOLDER_SQUARE} />
        </div>
        <div id="content">
          <Placeholder fluid>
            <Placeholder.Header />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
        </div>
      </StyledOrganizationCard>
    </Grid.Column>
    <Divider section />
  </>
);

export default BigListLoader;
